import { IconStar } from "../components/Icons";
import { VideoCarousel } from "../../../components/homeowner-user-landing-page/video-carousel";
import { reorderVideosByRequestedPattern } from "../../../components/homeowner-user-landing-page/reorder-videos";
import { testimonials } from "../data";

const carouselVideos = testimonials.videos.map((video) => ({
  title: video.title,
  description: "",
  videoBanner: video.thumbnail,
  url: video.url,
}));

const orderedCarouselVideos = reorderVideosByRequestedPattern(carouselVideos);

export const TestimonialsSection = () => (
  <section className="sg-section sg-testimonials">
    <div className="sg-container">
      <div className="sg-testimonials__header">
        <div className="sg-testimonials__stars">
          {Array.from({ length: 5 }).map((_, index) => (
            <IconStar key={`star-${index}`} size={24} />
          ))}
        </div>
        <blockquote className="sg-testimonials__quote">
          {testimonials.quote}
        </blockquote>
        <div className="sg-testimonials__name">
          <span className="sg-testimonials__name-text">{testimonials.name}</span>
          <span className="sg-testimonials__location">{testimonials.location}</span>
        </div>
        <p className="sg-testimonials__helper">{testimonials.helperText}</p>
      </div>

      <div className="sg-testimonials__carousel">
        <VideoCarousel videos={orderedCarouselVideos} />
      </div>
    </div>
  </section>
);
